import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1A36] text-white ag-noise"
    >
      {/* Marquee ribbon */}
      <div className="overflow-hidden border-y border-white/10 py-8">
        <div className="flex whitespace-nowrap ag-marquee will-change-transform">
          {Array.from({ length: 2 }).map((_, blockIdx) => (
            <div key={blockIdx} className="flex shrink-0">
              {Array.from({ length: 6 }).map((_, i) => (
                <span
                  key={i}
                  className="font-display text-5xl sm:text-7xl font-black tracking-tight mx-8 text-transparent"
                  style={{ WebkitTextStroke: "1px #D4AF37" }}
                >
                  BUILD. GROW. PROSPER.
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand column */}
          <div className="md:col-span-4 space-y-5">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
              <img src={COMPANY.logoUrl} alt={COMPANY.name} className="h-14 w-14 object-contain" />
              <div>
                <div className="font-display font-extrabold text-xl">ASSET GROUP</div>
                <div className="text-[10px] tracking-[0.25em] text-[#D4AF37]">PTE LIMITED</div>
              </div>
            </Link>
            <p className="text-sm text-white/70 max-w-sm">
              Fiji&apos;s trusted partner in construction, building and civil works.
              We build strong assets for a prosperous future.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a href="#" aria-label="Facebook" className="text-white/70 hover:text-[#D4AF37] ag-btn-hover" data-testid="footer-social-facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Instagram" className="text-white/70 hover:text-[#D4AF37] ag-btn-hover" data-testid="footer-social-instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-white/70 hover:text-[#D4AF37] ag-btn-hover" data-testid="footer-social-linkedin">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Explore</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-white/80 hover:text-white"
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Services</h4>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    className="text-sm text-white/80 hover:text-white"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3 space-y-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Contact</h4>
            <div className="text-sm text-white/85">{COMPANY.contactPerson}</div>
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-start gap-2 text-sm text-white/80 hover:text-white" data-testid="footer-phone">
              <Phone className="h-4 w-4 mt-0.5 text-[#D4AF37]" />
              {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-start gap-2 text-sm text-white/80 hover:text-white break-all" data-testid="footer-email">
              <Mail className="h-4 w-4 mt-0.5 text-[#D4AF37]" />
              {COMPANY.email}
            </a>
            <div className="flex items-start gap-2 text-sm text-white/80" data-testid="footer-address">
              <MapPin className="h-4 w-4 mt-0.5 text-[#D4AF37]" />
              <span>{COMPANY.address}</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase">Fiji · Construction · Civil Works</div>
        </div>
      </div>
    </footer>
  );
}
